import React, { ReactElement, ReactNode } from 'react';
import Tooltip from '../../../tooltip';
import classNames from 'classnames/bind';
import styles from './competencyInnerCard.module.scss';

const cx = classNames.bind(styles);

interface Props {
  title?: ReactElement | string; // 제목
  tooltipContent?: ReactNode;
  jobTitle?: ReactElement | string; // 직군 텍스트
  subTitle?: ReactElement | string; // 부제
  children?: React.ReactNode | string; // 내용
  small?: boolean; // 카드 크기(패딩 값 달라짐, 역량 프로필에서만 사용됨)
  contentMarginTop?: number; // 내용 위 마진값 임의 변경
}

const CompetencyInnerCard = ({
  title,
  children,
  small,
  jobTitle,
  subTitle,
  contentMarginTop,
  tooltipContent,
}: Props) => {
  return (
    <div className={cx('card', small ? 'small' : null)}>
      {title && (
        <div className={cx('titleArea')}>
          <em className={cx('title')}>{title}</em>
          {tooltipContent && <Tooltip type={'competency'} iconSize={'small'} content={tooltipContent} />}
        </div>
      )}
      {jobTitle && <span className={cx('jobTitle')}>{jobTitle}</span>}
      {subTitle && <p className={cx('subTitle')}>{subTitle}</p>}
      <div className={cx('content')} style={{ marginTop: contentMarginTop }}>
        {children}
      </div>
    </div>
  );
};

export default CompetencyInnerCard;
